<template>
  <div>
    <div v-if="isPreview" class="mask"></div>
    <rich-loading
      v-if="showLoading"
      :size="20"
      class="page-loading"
    ></rich-loading>
    <div v-if="!showLoading" :class="headTitle ? 'landing-page-container':'landing-page-container-white'" >
      <div
        class="landing-page-head"
        :style="{
          'background': `no-repeat top / 100% url(${firstScreenBg})`,
          'height': `${headTitle ? 'auto' : '100vh'}`,
          'box-sizing': `${headTitle ? 'content-box' : 'border-box'}`
        }"
      >
        <!-- 城市切换 -->
        <div class="landing-page-city" @click="jumpSelectCity">
          <span class="city-text">{{ this.cityName }}</span>
          <i class="icon-v3_outlined_entrance city-icon"/>
        </div>
        <template v-if="headTitle">
          <!-- 标题 -->
          <div class="landing-page-title">
            <div class="title-text">{{ headTitle }}</div>
            <div class="title-subtitle" v-html="$t('FoodD_optimization_WVNI_kCwK', {day: `<div class='highlight'>${ countdownTip.day }</div>`, hour: `<div class='highlight'>${countdownTip.hour}</div>`})"></div>
          </div>
          <!-- 分享 -->
          <guide-share v-if="Object.keys(share).length" :trackAttrs="trackAttrs" :share="share" @handle-scroll="setScrollHidden" />
          <!-- 活动规则 -->
          <activity-rules v-if="Object.keys(rule).length" :rule="rule" @clickToDetail="jumpToRules" class="landing-page-rules" />
          <!-- 推荐记录 -->
          <recommend-records :records="records" />
        </template>
        <template v-else>
          <no-activity :share="share"/>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCity from "./selectCity";
import GuideShare from './modules/guideShare'
import ActivityRules from './modules/activityRules'
import RecommendRecords from './modules/recommendRecords' 
import NoActivity from './modules/noActivity'
import trackEvent from "@/common/js/track"
import { dgdButtonClick } from '@/page/d/xtd/config/getTrack'
import { getXtdPreviewDataV2 } from './config/previewDataV2.js'
import { mapActions } from "vuex";
import { urlParse } from "@/common/js/utils";
import {
  getUserInfo,
  setTitle,
  showNavigationBarRightItem,
  setBackPressListener,
  closePage
} from "@/common/js/bridge";

export default {
  name: 'LandingPageV2',
  components: {
    SelectCity,
    GuideShare,
    ActivityRules,
    RecommendRecords,
    NoActivity
  },
  data() {
    return {
      cityName: '',
      currentCityId: 0,
      config: {},
      showLoading: false,
      trackAttrs: {}
    }
  },
  async created () {
    setTitle(this.gettext("推荐骑手"))
    await this.init()
    setBackPressListener(true, () => {
      setBackPressListener(false)
      dgdButtonClick({
        ...this.trackAttrs,
        click_type: 3
      })
      closePage()
    })
    this.trackPreview()
  },
  beforeDestroy () {
    showNavigationBarRightItem('', () => {})
    setBackPressListener(false)
  },
  computed: {
    cityList () {
      const { config: {cityList} = {} } = this
      return cityList || []
    },
    share () {
      const { config: {share} = {} } = this
      return share || {}
    },
    firstScreenBg () {
      const { share: {imgUrl} = {} } = this
      return imgUrl || ''
    },
    headTitle () {
      const { share: {title} = {} } = this
      return title || ''
    },
    countdownTip () {
      const { share: {countdownTip} = {} } = this
      return countdownTip || {}
    },
    rule () {
      const { config: {rule} = {} } = this
      return rule || {}
    },
    records () {
      const { config: {records} = {} } = this
      return records || []
    },
    isPreview () {
      const { query: {preview} } = this.$route
      return !!preview
    }
  },
  methods: {
    ...mapActions(['getXtdConfigInfoV2', 'getGlobalInfo']),
    async init () {
      const { isPreview } = this
      if (isPreview) {
        const res = getXtdPreviewDataV2()
        const { cityName = '', cityID = 0 } = res
        this.cityName = cityName
        this.currentCityId = cityID
        this.config = res
      } else {
        this.showLoading = true
        await this.refreshInfo()
      }
    },
    async fetchAcquisitionConfig (data) {
      const res = await this.getXtdConfigInfoV2(data) || {}
      const { cityName = '', cityID = 0 } = res
      this.cityName = cityName
      this.currentCityId = cityID
      this.config = res
      // 展示右上角history按钮
      showNavigationBarRightItem(this.$t('FoodD_optimization_hPwx_hGCS'/** 历史 */), this.jumpToHistory)
      return res
    },
    // floating弹出背景不可滚动
    setScrollHidden (isShow) {
      let ele=document.getElementById('app');
      if(isShow){
        ele.style.overflow='hidden';
      }else{
        ele.style.overflow='';
      }
    },
    jumpSelectCity() {
      const { cityList = [], cityName } = this
      this.setScrollHidden(true)
      this.$Floating({
        type: "confirm",
        height: "90%",
        btnOkText: this.$t("soda-m-i18n---完成" /* 完成 */),
        btnCancelText: this.$t("soda-m-i18n---取消" /* 取消 */),
        onOk: async () => {
          this.showLoading = true;
          this.refreshInfo()
          this.setScrollHidden(false)
          return true
        },
        onCancel: () => {
          this.setScrollHidden(false)
        },
        content: (
          <select-city
            cityList={cityList}
            locationCity={cityName}
            on-selected={this.handleSelected}
          />
        ),
      });
    },
    getSourceInfo() {
      return Promise.all([this.getGlobalInfo(), getUserInfo()])
        .then((data) => {
          this.sourceType = "d";
          this.sourceID = data[1].uid;
          return {
            ...data[0],
            ...data[1],
            sourceType: "d",
            sourceID: data[1].uid,
          };
        })
        .catch((err) => {
          console.log("err", err.msg);
        });
    },
    handleSelected(city) {
      const { cityId, cityName } = city
      this.currentCityId = cityId
      this.cityName = cityName
    },
    jumpToHistory () {
      this.$router.push({
        path: `/d/rewardlist`
      })
    },
    jumpToRules () {
      const { currentCityId } = this
      this.$router.push({
        path: `/d/detailRules`,
        query: {
          isNew: true,
          cityId: currentCityId
        }
      })
    },
    async refreshInfo () {
      try {
        const { currentCityId } = this
        const data = await this.getSourceInfo()
        let param = {
          ...data,
          sourceType: "d",
          sourceID: "d",
          ...(currentCityId && { cityId: currentCityId }),
          required: true,
        }
        const res = await this.fetchAcquisitionConfig(param);
        const { activityID, cityID } = res
        const { riderId, country } = data
        // 拼接埋点参数
        this.trackAttrs = {
          reward_id: activityID,
          rider_id: riderId,
          city_id: cityID,
          country,
        }
      } finally {
        this.showLoading = false
      }
    },
    trackPreview() {
      const { trackAttrs: {reward_id, rider_id} = {} } = this
      const QUERY_PARAMS = urlParse()
      const entrance = QUERY_PARAMS["entrance"] || ""
      trackEvent({
        eventId: "sailing_d_x_recommend_sw",
        eventLabel: "X推D落地页展示",
        attrs: {
          from_resource:  1, // 在dapp中传1
          version: reward_id, // version的值同reward_id一致
          entrance: entrance, // 页面入口来源，如App_OpenAds(开屏banner)、Sidebar_Referral(侧边栏入口)等
          page_version: 2, // 落地页版本号：1是旧版本 2是新版本
          rider_id,
          reward_id,
        },
      });
    }
  }
}
</script>

<style lang='stylus' scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11;
}
.landing-page-head {
  padding: 24px 32px 56px;
}
.landing-page-rules {
  margin: 56px 0 24px;
}
.landing-page-container {
  background: rgba(0,0,0,0.06);
}
.landing-page-container-white {
  background: linear-gradient(180deg, #F5F5F7 0%, #FFFFFF 16%);
}
.landing-page-city {
  border-radius: 30px;
  padding: 12px 16px 12px 20px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: fit-content;

  .city-text {
    padding-right: 4px;
    font-family: DiDiSans-Pro-Medium;
    font-size: 24px;
    color: #000;
    line-height: 24px;
    font-weight: 500;
  }

  .city-icon {
    font-size: 16px;
    font-weight: 800;
    color: rgba(0, 0, 0, .6)

  }
}
.landing-page-title {
  margin-top: 24px;
  margin-bottom: 600px;

  .title-text {
    font-family: DiDiSans-Pro-Bold;
    font-size: 64px;
    color: #000;
    letter-spacing: 0;
    text-align: center;
    line-height: 72px;
  }

  .title-subtitle {
    font-family: DiDiSans-Pro-Regular;
    margin: 24px 32px 0;
    font-size: 28px;
    color: rgba(0, 0, 0, .5);
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.page-loading {
  position: absolute;
  top: 50%;
  width: 100%;
}
::v-deep .highlight {
  background-color: #263B2A;
  color: #fff;
  width: 44px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin: 0 8px;
}
</style>
